<template>
  <div class="header">
    <!-- 前往主页按钮 -->
    <router-link to="/#" style="color: #F2F8FE" @click.native="goToIndex">
      <div class="logo" style="position: absolute;" v-if="!ismobile">
        <div class="collapse-btn">
          <i class="el-icon-s-home"></i>
        </div>
        <h3 style="width:230px;">会员游戏列表</h3>
      </div>
      <div class="appLogo" style="position: absolute;" v-if="ismobile">
        <h3
          style="width: 110px; height: 50px; margin-left: 15px; font-size: 16px;"
        >
          会员游戏列表
        </h3>
      </div>
    </router-link>

    <div class="header-right">
      <div class="header-user-con">
        <a href="/cdk" class="header-link"> 兑换 </a>
        &nbsp;&nbsp;
        <a href="/order" class="header-link">我的租号</a>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ username }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <template v-if="userData && userData.level != 0">
              <el-dropdown-item>
                <div class="membership-card">
                  <div class="membership-level">
                    <span>会员等级： </span>
                    <span :class="['vip-level', 'level-' + userData.level]">{{
                      membershipLevel
                    }}</span>
                  </div>
                  <div class="membership-expiry">
                    <span>到期时间： </span>
                    <p :class="{ 'expiry-soon': isExpirySoon }">
                      {{ userData.expiryDate }}
                    </p>
                  </div>
                </div>
              </el-dropdown-item>
            </template>
            <template v-else>
              <el-dropdown-item>
                <div class="membership-card" @click="openToDialog">
                  <div class="membership-level">
                    <span>开通会员，全站游戏免费玩！</span>
                  </div>
                </div>
              </el-dropdown-item>
            </template>
            <el-dropdown-item divided command="loginout">
              {{ loginText }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 新设计的续费弹窗 -->
    <el-dialog
      title="开通会员全站游戏免费玩！"
      :visible.sync="renewDialog"
      width="320px"
      class="renew-dialog"
      center
    >
      <div class="new-price-container">
        <div
          v-for="(item, index) in priceOptions"
          :key="index"
          class="price-option"
          @click="selectOption(index)"
        >
          <div class="price-info">
            <span class="price">{{ item.price }}</span>
            <span class="duration">/{{ item.duration }}</span>
          </div>
          <div class="checkmark" v-show="selectedIndex === index">
            <i class="el-icon-check"></i>
          </div>
        </div>

        <div
          class="pay-button"
          @click="handlePayment"
          :class="{ disabled: selectedIndex === null }"
        >
          点击支付
        </div>
      </div>
    </el-dialog>

    <!-- 二维码支付弹窗 -->
    <el-dialog
      title="微信扫码支付"
      :visible.sync="qrDialogVisible"
      width="400px"
      center
    >
      <div style="text-align:center;">
        <img
          :src="qrCodeUrl"
          alt="支付二维码"
          style="width:200px;height:200px;margin-bottom:20px;"
        />
        <p style="color:#999;font-size:20px;">
          支付完成后请刷新页面查看会员状态
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserInfo,
  getMemberInfo,
  wechatPay,
  getMemberOrder,
  wechatNativePay
} from "@/api";
import { EventBus } from "@/utils/eventBus.js";

export default {
  data() {
    return {
      collapse: false,
      fullscreen: false,
      name: "租个游戏",
      message: 2,
      drawer: false,
      ismobile: false,
      userData: null,
      renewDialog: false,
      selectedIndex: null,
      priceOptions: [], // 改为空数组，由接口填充
      qrDialogVisible: false,
      qrCodeUrl: "",
    };
  },
  computed: {
    username() {
      if (this.userData && this.userData.phone) {
        return this.userData.phone;
      } else {
        return "未登录";
      }
    },
    loginText() {
      if (localStorage.getItem("token")) {
        return "退出登录";
      } else {
        return "去登录";
      }
    },
    membershipLevel() {
      switch (this.userData.level) {
        case 0:
          return "无会员";
        case 1:
          return "初级";
        case 2:
          return "中级";
        case 3:
          return "高级";
        case 4:
          return "终身";
        default:
          return "未知等级";
      }
    },
    isExpirySoon() {
      if (!this.userData || !this.userData.expiryDate) return false;
      const expiryDate = new Date(this.userData.expiryDate);
      const today = new Date();
      const diffTime = expiryDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 7; // 如果会员在7天内到期
    }
  },

  methods: {
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == "loginout") {
        localStorage.removeItem("ms_username");
        localStorage.removeItem("token");
        this.$router.push("/login");
      }
    },
    async goToIndex(event) {
      this.$router.replace("/index");
      if (this.$route.path === "/index" || this.$route.path === "/appIndex") {
        EventBus.$emit("clearSearchValue"); // 向事件总线发送事件
      }
    },
    openToDialog() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$message({
          message: "请登录后再来开通会员吧～",
          type: "warning"
        });
        return;
      }

      this.renewDialog = true;
    },
    isMobile() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent.toLowerCase()
      );
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit("collapse", this.collapse);
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    async getUsersInfo() {
      try {
        const { data } = await getUserInfo({
          token: localStorage.getItem("token")
        });

        if (data.code === 0 && data.data) {
          this.userData = data.data;
        } else {
          console.warn("未获取到有效的用户数据");
          this.userData = null;
        }
      } catch (error) {
        console.error("获取用户信息时发生错误：", error);
        this.userData = null;
      }
    },
    // 添加获取会员信息的方法
    async fetchMemberInfo() {
      try {
        const { data } = await getMemberInfo();
        if (data.code === 0) {
          this.priceOptions = data.data.map(item => {
            let duration = "";
            if (item.activationDuration < 24) {
              duration = `${item.activationDuration}小时`;
            } else if (item.activationDuration === 720) {
              duration = "月会员";
            } else if (item.activationDuration === 2160) {
              // 3个月=90天=2160小时
              duration = "季会员";
            } else if (item.activationDuration === 8760) {
              // 1年=365天=8760小时
              duration = "年会员";
            } else {
              duration = `${item.activationDuration / 24}天`;
            }
            return {
              price: `${item.price}元`,
              duration: duration,
              originalData: item // 保留原始数据供后续使用
            };
          });
        }
      } catch (error) {
        console.error("获取会员信息失败:", error);
        // 设置默认值以防接口失败
        this.priceOptions = [
          { price: "10元", duration: "6小时" },
          { price: "15元", duration: "12小时" },
          { price: "78元", duration: "月会员" }
        ];
      }
    },
    selectOption(index) {
      this.selectedIndex = index;
    },
    async handlePayment() {
      if (this.selectedIndex === null) {
        this.$message({
          message: "请选择购买时长",
          type: "warning"
        });
        return;
      }

      const token = localStorage.getItem("token");
      if (!token) {
        this.$message({
          message: "请登录后再来开通会员吧～",
          type: "warning"
        });
        return;
      }

      const selectedOption = this.priceOptions[this.selectedIndex];
      const memberId = selectedOption.originalData.id;

      // 微信环境内支付
      if (typeof WeixinJSBridge !== "undefined") {
        const { data: payData } = await wechatPay({
          token: token,
          memberId: memberId
        });

        const vx_data = {
          appId: payData.data.appId,
          timeStamp: payData.data.timeStamp,
          nonceStr: payData.data.nonceStr,
          package: payData.data.package,
          signType: payData.data.signType,
          paySign: payData.data.paySign
        };

        WeixinJSBridge.invoke("getBrandWCPayRequest", vx_data, res => {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            this.$message({
              message: "支付成功",
              type: "success"
            });
            this.renewDialog = false;
            this.fetchItems();
          } else {
            this.$message({
              message: "支付失败: " + (res.err_msg || "未知错误"),
              type: "error"
            });
          }
        });
      }
      // 微信环境外使用二维码支付
      else {
        try {
          const { data } = await wechatNativePay({
            token: token,
            memberId: memberId
          });

          if (data.code === 0) {
            this.qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(
              data.data.url
            )}`;
            this.qrDialogVisible = true;
          } else {
            this.$message({
              message: data.msg || "创建支付订单失败",
              type: "error"
            });
          }
        } catch (error) {
          this.$message({
            message: error.message || "支付请求失败",
            type: "error"
          });
        }
      }
    },
    openRenewDialog() {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$message({
          message: "请登录后再来开通会员吧～",
          type: "warning"
        });
        return;
      }
      this.renewDialog = true;
    }
  },
  created() {
    if (localStorage.getItem("token")) {
      this.getUsersInfo();
    }
    this.fetchMemberInfo(); // 添加获取会员信息
  },
  mounted() {
    if (this.isMobile()) {
      this.ismobile = true;
    } else {
      this.ismobile = false;
    }
    EventBus.$on("getVipNumber", this.getUsersInfo);
    EventBus.$on("openToDialog", this.openRenewDialog);
  },
  beforeDestroy() {
    EventBus.$off("getVipNumber", this.getUsersInfo); // 移除事件监听
    EventBus.$off("openToDialog", this.openRenewDialog); // 移除事件监听
  }
};
</script>

<style scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  font-size: 22px;
  color: #fff;
  background-color: #409eff;
}
.collapse-btn {
  float: left;
  padding: 0 21px;
  line-height: 50px;
}
.header .logo {
  float: left;
  width: 180px;
  line-height: 50px;
}
.header .appLogo {
  float: left;
  width: 60px;
  line-height: 50px;
}
.header-right {
  float: right;
  padding-right: 20px;
}
.header-user-con {
  display: flex;
  height: 50px;
  align-items: center;
}
.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}
.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}
.btn-bell .el-icon-bell {
  color: #fff;
}
.user-name {
  margin-left: 10px;
  font-size: 16px;
  font-weight: bold; /* 加粗字体 */
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

/* 会员信息卡片样式 */
.membership-card {
  padding: 10px;
  border-radius: 8px;
  background-color: #f5f7fa;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.membership-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
}

.membership-level,
.membership-expiry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.membership-level span,
.membership-expiry span {
  font-size: 14px;
  color: #606266;
}

.membership-expiry p {
  margin: 0;
  font-size: 14px;
  color: #303133;
}

/* 会员等级样式 */
.vip-level {
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  color: white;
}

.level-1 {
  background-color: #ffffff; /* 初级会员 */
}

.level-2 {
  background-color: #ffffff; /* 中级会员 */
}

.level-3 {
  background-color: #ffffff; /* 高级会员 */
}

.level-4 {
  background-color: #ffffff; /* 终身会员 */
}

/* 会员到期时间提示 */
.expiry-soon {
  color: #f56c6c; /* 红色提示 */
  font-weight: bold;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .membership-card {
    padding: 8px;
  }

  .membership-level,
  .membership-expiry {
    flex-direction: column;
    align-items: flex-start;
  }

  .membership-level span,
  .membership-expiry span {
    font-size: 12px;
  }

  .membership-expiry p {
    font-size: 12px;
  }
}

/* 链接样式 */
.header-link {
  color: white;
  font-size: 16px;
  font-weight: bold; /* 加粗字体 */
  margin-right: 20px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.header-link:hover {
  color: #c6e2ff; /* 鼠标悬停时改变颜色 */
}

@media (max-width: 768px) {
  .header-link {
    font-size: 12px;
    margin-right: 5px;
  }
}

.membership-card .membership-level span {
  color: #409eff; /* 蓝色提示 */
  font-weight: bold;
  font-size: 14px;
}

/* 新设计的续费弹窗样式 */
.renew-dialog >>> .el-dialog {
  border-radius: 12px;
  margin-top: 10vh !important; /* 新增这一行 */
}

.renew-dialog >>> .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.renew-dialog >>> .el-dialog__title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.new-price-container {
  padding: 10px 15px;
}

.price-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  margin-bottom: 10px;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.price-option:hover {
  border-color: #c0c4cc;
  background-color: #f5f7fa;
}

.price-info {
  font-size: 16px;
}

.price {
  font-weight: bold;
  color: #333;
}

.duration {
  color: #666;
}

.checkmark {
  color: #4caf50;
  font-size: 18px;
  font-weight: bold;
}

.pay-button {
  margin-top: 20px;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #409eff; /* 修改为Element UI的主色 */
  color: white; /* 文字改为白色 */
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
}

.pay-button:not(.disabled):hover {
  background-color: #66b1ff; /* 悬停时颜色变浅 */
}

.pay-button.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  background-color: #c0c4cc; /* 禁用状态使用灰色 */
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue